// extracted by mini-css-extract-plugin
export default {"label":"Input_label__XvWTY","title":"Input_title__IMwxF","input":"Input_input__Ba4RU","description":"Input_description__Rngbh","error-message":"Input_error-message__keFL-"};